
const elem = document.querySelector('.gallery-container'),
      modal = document.querySelector('.gallery .gallery-modal'),
      loader = document.querySelector('.gallery .loader'),
      r = document.querySelector(':root');

let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px',
    videos = document.querySelectorAll('.gallery video');

if (document.querySelector('.gallery')) {
    document.addEventListener("DOMContentLoaded", () => {

        const playersGallery = Plyr.setup('.gallery-container video', {
            controls: [],
            clickToPlay: false
        });

        const playersGalleryModal = Plyr.setup('section.gallery .gallery-modal video', {
            controls: ['play'],
        });

        initMasonry();

        function initMasonry() {
            // imagesLoaded(elem, function (instance) {
                setTimeout(() => {

                elem.classList.add('loaded');
                loader.classList.add('loaded'); // Fade spinning loader out

                setTimeout(() => {
                    loader.classList.add('hidden'); //remove it
                }, 800);

                    // msnry.layout()
                    // console.log('masonry init');

                    let msnry = new Masonry(elem, {
                        itemSelector: '.image-item',
                        columnWidth: '.grid-sizer',
                        percentPosition: true,
                        // gutter: 60,
                        gutter: '.gutter-sizer',
                        horizontalOrder: true
                    });

                }, 800);

                ScrollOut({ //gallery
                    targets: '[data-scroll-g]',
                    threshold: 0,
                    once: true,
                });
        } // masonry init

    });

    const gallery = document.querySelector('.gallery');

    gallery.querySelectorAll('.gallery-container figure').forEach((modalBtn) => {
        modalBtn.addEventListener('click', () => {
            openModal(modalBtn.getAttribute('data-index'));
        });
    });


    gallery.querySelector('.gallery .gallery-modal .close').addEventListener('click', () => {
        closeModal();
    });
}


function openModal(index) {
    slideTo(index);

    modal.classList.add('open');
    document.body.classList.add('modal-open');
    r.style.setProperty('--scrollbar-width', scrollbarWidth);

    bodyScrollLock.disableBodyScroll(modal, {
        reserveScrollBarGap: true
    });
}


function closeModal() {
    r.style.setProperty('--scrollbar-width', '0px');
    modal.classList.remove('open');
    document.body.classList.remove('modal-open');

    bodyScrollLock.enableBodyScroll(modal);
}

//Swiper for gallery overlay
export const initSwiper = () => {
    swiperGallery = new Swiper(document.querySelector('.swiper.gallery-carousel'), {
        loop: false,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        // effect: 'fade',
        // fadeEffect: {
        //     crossFade: true
        // },
        // effect: 'fade',
        effect: 'slide',

        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        // keyboard: { onlyInViewport: true },

        autoHeight: false, //true
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },

        // breakpoints: {
        //     1025: {
        //         effect: 'fade',
        //     },
        // }
    });
};

export const slideTo = (index) => { // find index of clicked gallery item and then go to that slide
    if (swiperGallery) {
        // swiperGallery.slideTo(Number(index) + 1, 0);
        swiperGallery.slideTo(Number(index), 0);
    }
};



initSwiper();